import React, { useEffect, useRef, useState } from 'react'
import Layout from '../common/Layout'
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from 'react-hook-form';
import ApiHelper from '../../helperFunction/ApiHelper';
import API_ENDPOINTS from '../../helperFunction/Constant';
import { Toast } from 'primereact/toast';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

const AddBanner = () => {

    const { id } = useParams()
    const isEdit = id ? true : false
    const toast = useRef(null)
    const navigate = useNavigate()

    const [bannersData, setBannersData] = useState([])

    useEffect(() => {
        isEdit && getBanners()
    }, [])

    const schema = yup.object({
        bannerTitle: yup.string().required("Title is required"),
        bannerWebImage: yup.mixed().test("image-required", "Web Image is required", function (value) { return ((value && value.length > 0) || bannersData?.bannerWebImage); }),
        bannerUrl: yup.string().required("URL is required"),
        bannerMobileImage: yup.mixed().test("image-required", "Mobile Image is required", function (value) { return ((value && value.length > 0) || bannersData?.bannerMobileImage); }),
        isActive: yup.boolean(),
    });

    const { register, handleSubmit, reset, resetField, watch, formState: { errors }, } = useForm({ resolver: yupResolver(schema), });

    const resetValue = () => {
        reset({
            bannerTitle: '',
            bannerWebImage: null,
            bannerMobileImage: null,
            bannerUrl: '',
            isActive: '',
        })
    }

    const previewWebImage = watch('bannerWebImage')
    const previewMobileImage = watch('bannerMobileImage')

    const getBanners = (data) => {
        ApiHelper.get(`${API_ENDPOINTS.BANNER}/${id}`, data).then((res) => {
            if (res.status === 200) {
                setBannersData(res.data.data)
                reset({
                    bannerTitle: res.data.data.bannerTitle,
                    bannerUrl: res.data.data.bannerUrl,
                    isActive: res.data.data.isActive,
                })
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };

    const onSubmit = (data) => {
        const formData = new FormData()
        for (const [key, value] of Object.entries(data)) {
            formData.append(key, value);
        };
        if (data.bannerWebImage) {
            formData.append('bannerWebImage', data.bannerWebImage[0]);
        }
        if (data.bannerMobileImage) {
            formData.append('bannerMobileImage', data.bannerMobileImage[0]);
        }
        if (isEdit) {
            update(formData)
        } else {
            add(formData)
        }
    };

    const add = (data) => {
        ApiHelper.post(`${API_ENDPOINTS.BANNER}/`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setTimeout(() => {
                    navigate('/banners')
                }, 1500)
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };

    const update = (data) => {
        ApiHelper.put(`${API_ENDPOINTS.BANNER}/${id}`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                setTimeout(() => {
                    navigate('/banners')
                }, 1500)
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };

    const confirmDeleteDailog = (imageType) => {
        confirmDialog({
            message: 'Do you want to delete this record?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            defaultFocus: null,
            acceptClassName: 'p-button-danger',
            accept: () => deleteImage(imageType),
        });
    };

    const deleteImage = (imageType) => {
        ApiHelper.post(`${API_ENDPOINTS.BANNER}/${imageType === 'web' ? 'delete-web-image' : 'delete-mobile-image'}/${id}`).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 });
                getBanners();
            }
        }).catch((err) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: err.response?.data?.message, life: 3000 });
        });
    };

    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />
            <Layout>
                <div class="content-wrapper">
                    <div class="container-xxl flex-grow-1 container-p-y">
                        <div class="d-flex justify-content-between align-items-center py-3">
                            <h4 class="fw-bold py-3 mb-2">
                                <span class="d-flex text-muted fw-light"> 
                                    <p class="breadcrumb-item pageHeader active me-2 mb-0" aria-current="page" onClick={() => navigate('/banners')}> Banners </p> / <b className='mx-2'> {isEdit ? 'Edit' : "Add"} </b>
                                </span>
                            </h4>
                            <Link to="/banners" class="btn btn-secondary">⬅ Go Back</Link>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card mb-4">
                                    <div class="card-body">
                                        <form onSubmit={handleSubmit(onSubmit)}>
                                            <div class="row mb-3">
                                                <div class="col-md-3">
                                                    <label class="form-label">Title</label>
                                                    <input type="text" name="bannerTitle" class="form-control" {...register("bannerTitle")} />
                                                    <small className="text-danger">{errors.bannerTitle?.message}</small>
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="form-label">URL</label>
                                                    <input type="text" name="bannerUrl" class="form-control" {...register("bannerUrl")} />
                                                    <small className="text-danger">{errors.bannerUrl?.message}</small>
                                                </div>
                                                {bannersData?.bannerWebImage ? (
                                                    <div class="col-md-3">
                                                        <label class="form-label">Web Image</label>
                                                        <br />
                                                        <div class="mt-3">
                                                            <div class="d-inline-block ">
                                                                <div class="position-relative " style={{ width: "fit-content;" }}>
                                                                    <a target="_blank">
                                                                        <img src={`${process.env.REACT_APP_BASE_URL}/${bannersData.bannerWebImage}`} id="existingImagePhoto" class="img-thumbnail" />
                                                                    </a>
                                                                    <button type="button" class="btn btn-danger btn-sm position-absolute top-0 end-0" onClick={() => confirmDeleteDailog('web')}> &times; </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div class="col-md-3">
                                                        <label class="form-label">Upload Web Image</label>
                                                        <br />
                                                        <div>
                                                            <input type="file" accept=".jpeg, .jpg, .png, .webp" name="bannerWebImage" {...register("bannerWebImage")} class="form-control" />
                                                        </div>
                                                        <small className="text-danger">{errors.bannerWebImage?.message}</small>
                                                        {previewWebImage?.[0] && (
                                                            <div class="mt-1">
                                                                <div class="d-inline-block ">
                                                                    <div class="position-relative " style={{ width: "fit-content;" }}>
                                                                        <a target="_blank">
                                                                            <img src={URL.createObjectURL(previewWebImage[0])} id="existingImagePhoto" class="img-thumbnail" />
                                                                        </a>
                                                                        <button type="button" class="btn btn-danger btn-sm position-absolute top-0 end-0" onClick={() => resetField('bannerWebImage')}> &times; </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                )
                                                }
                                                {bannersData?.bannerMobileImage ? (
                                                    <div class="col-md-3">
                                                        <label class="form-label">Mobile Image</label>
                                                        <br />
                                                        <div class="mt-3">
                                                            <div class="d-inline-block ">
                                                                <div class="position-relative " style={{ width: "fit-content;" }}>
                                                                    <a target="_blank">
                                                                        <img src={`${process.env.REACT_APP_BASE_URL}/${bannersData.bannerMobileImage}`} id="existingImagePhoto" class="img-thumbnail" />
                                                                    </a>
                                                                    <button type="button" class="btn btn-danger btn-sm position-absolute top-0 end-0" onClick={() => confirmDeleteDailog('mobile')}> &times; </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div class="col-md-3">
                                                        <label class="form-label">Upload Mobile Image</label>
                                                        <br />
                                                        <div>
                                                            <input type="file" accept=".jpeg, .jpg, .png, .webp" name="bannerMobileImage" {...register("bannerMobileImage")} class="form-control" />
                                                        </div>
                                                        <small className="text-danger">{errors.bannerMobileImage?.message}</small>
                                                        {previewMobileImage?.[0] && (
                                                            <div class="mt-1">
                                                                <div class="d-inline-block ">
                                                                    <div class="position-relative " style={{ width: "fit-content;" }}>
                                                                        <a target="_blank">
                                                                            <img src={URL.createObjectURL(previewMobileImage[0])} id="existingImagePhoto" class="img-thumbnail" />
                                                                        </a>
                                                                        <button type="button" class="btn btn-danger btn-sm position-absolute top-0 end-0" onClick={() => resetField('bannerMobileImage')}> &times; </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                )
                                                }
                                                <div class="col-md-3">
                                                    <label class="form-label">Status</label>
                                                    <div class="form-check form-switch mb-2">
                                                        <input class="form-check-input mt-2" name="isActive" type="checkbox" id="flexSwitchCheckDefault" {...register("isActive")} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-4">
                                                <button type="submit" class="btn btn-primary me-3">Save</button>
                                                <button type="button" onClick={() => resetValue()} class="btn btn-secondary reset-btn">Reset</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default AddBanner
